import { render } from "./SMSLog.vue?vue&type=template&id=535b4510&scoped=true"
import script from "./SMSLog.vue?vue&type=script&lang=js"
export * from "./SMSLog.vue?vue&type=script&lang=js"

import "./SMSLog.vue?vue&type=style&index=0&id=535b4510&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535b4510"]])

export default __exports__